import './assets/css/styles.css';
import './assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Preloader from "./assets/js/preloader.js";
import { NavLink } from "react-router-dom";

import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc, onSnapshot, runTransaction, orderBy, query, where, Timestamp, setDoc } from 'firebase/firestore';

import { ref, uploadBytes, getDownloadURL, getStorage } from 'firebase/storage';

import { increment } from 'firebase/firestore';

import { useCookies } from 'react-cookie';

import OwlCarousel from 'react-owl-carousel';
import './assets/css/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import AnimatePage from './subpages/animatepage.js';


const firebaseConfig = {
    apiKey: "AIzaSyAA9pZNLAu4ucWymqChIP0dxZGpU_AgPIo",
    authDomain: "drops0n.firebaseapp.com",
    databaseURL: "https://drops0n-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "drops0n",
    storageBucket: "drops0n.appspot.com",
    messagingSenderId: "324397004638",
    appId: "1:324397004638:web:7746b8670bdf68142141cf",
    measurementId: "G-6LKYNNC86J"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);



const options = {
    singleItem: true,
    autoHeight: false,
    autoplayHoverPause: true,
    responsiveClass: true,
    navText: [
        "<i class='fa fa-chevron-left'></i>",
        "<i class='fa fa-chevron-right'></i>"
    ],
    dots: true
};

const responsive = {
    0: {
        dotsEach: 6,
        items: 1,
    },
    600: {
        dotsEach: 6,
        items: 2,
    },
    1300: {
        dotsEach: 6,
        items: 3,
    },
    1600: {
        dotsEach: 6,
        items: 4,
    }
};





const Home = () => {
    const [items, setItems] = useState([]);
    const [archItems, setArchItems] = useState([]);
    const [clickedItems, setClickedItems] = useState([]);
    const [cookies, setCookie] = useCookies(['clickedItems']);

    const now = new Date();

    const itemsCollectionRef = query(collection(db, 'items'), orderBy('timestamp'), where('timestamp', '>=', now));

    const archItemsCollectionRef = query(collection(db, 'items'), orderBy('timestamp', 'desc'), where('timestamp', '<', now));

    useEffect(() => {
        getItems();
        // Update the local clickedItems state with the cookie value
        setClickedItems(cookies.clickedItems || []);
        // Listen for changes to the items collection
        const unsubscribe = onSnapshot(itemsCollectionRef, (snapshot) => {
            const itms = snapshot.docs.map((doc) => ({
                data: doc.data(),
                id: doc.id,
            }));
            setItems(itms);
        });

        // Return a function to unsubscribe from the snapshot listener
        return () => unsubscribe();
    }, []);

    function getItems() {
        getDocs(itemsCollectionRef)
            .then((response) => {
                const itms = response.docs.map((doc) => ({
                    data: doc.data(),
                    id: doc.id,
                }));
                setItems(itms);
                console.log(itms);
            })
            .catch((error) => console.log(error.message));

        getDocs(archItemsCollectionRef)
            .then((response) => {
                const itms = response.docs.map((doc) => ({
                    data: doc.data(),
                    id: doc.id,
                }));
                setArchItems(itms);
                console.log(itms);
            })
            .catch((error) => console.log(error.message));
    }

    function handleResellClick(event, itemId) {
        event.preventDefault();
        // Check if the item has already been clicked
        if (clickedItems.includes(itemId)) {
            console.log('Item has already been clicked');
            // Decrement the hype value in a transaction
            const itemRef = doc(db, 'items', itemId);
            runTransaction(db, (transaction) => {
                return transaction.get(itemRef).then((itemDoc) => {
                    if (!itemDoc.exists()) {
                        throw 'Item does not exist!';
                    }

                    const currentHype = itemDoc.data().hype;
                    if (currentHype === 0) {
                        return;
                    }

                    transaction.update(itemRef, { hype: increment(-1) });
                    setClickedItems(clickedItems.filter((id) => id !== itemId));
                    setCookie('clickedItems', clickedItems.filter((id) => id !== itemId));
                });
            })
                .then(() => {
                    console.log('Item updated successfully');
                })
                .catch((error) => {
                    console.error('Error updating item: ', error);
                });
        } else {
            const itemRef = doc(db, 'items', itemId);
            const newHype = increment(1);

            updateDoc(itemRef, {
                hype: newHype,
            })
                .then(() => {
                    console.log('Item updated successfully');
                    // Add the item ID to the list of clicked items in the cookie and the local state
                    setCookie('clickedItems', [...clickedItems, itemId]);
                    setClickedItems([...clickedItems, itemId]);
                })
                .catch((error) => {
                    console.error('Error updating item: ', error);
                });
        }
    };


    return (
        <div>
            <AnimatePage>
                <section className="home">
                    <section className="drop">

                        {items.map(item => (
                            <span className="item">
                                <OwlCarousel className="img-carousel one" options={options} items={1} dots={false} nav >
                                    {item.data.img1 && <img src={item.data.img1} alt="item-img-1" />}
                                    {item.data.img2 && <img src={item.data.img2} alt="item-img-2" />}
                                    {item.data.img3 && <img src={item.data.img3} alt="item-img-3" />}
                                </OwlCarousel>
                                <div className="name">{item.data.name}<span>{item.data.colorway}</span></div>
                                <div className="price">{item.data.price} <span>{item.data.currency}</span></div>
                                <div className="time">{item.data.day}<span>{item.data.month}</span></div>
                                <a href={item.data.link ? item.data.link : "./"} className={`link ${!item.data.link ? "un" : ""}`}>
                                    SKLEP
                                </a>
                                <div className={`resell ${clickedItems.includes(item.id) ? 'clicked' : ''}`} onClick={(event) => handleResellClick(event, item.id)}>
                                    <i className="fa-solid fa-fire"></i>{item.data.hype}
                                </div>
                                <div className={`women ${item.data.women ? 's' : ''}`}><i className="fa-solid fa-venus"></i></div>
                            </span>
                        ))}
                    </section>

                    <div className="arch" id="" data-scroll-index="1" style={{ marginTop: "180px" }}>
                        <section className="privacy">
                            <span className="privacy_policy">Archiwalne<span style={{ color: "#DAA520" }}>Dropy</span></span>
                        </section>
                        <OwlCarousel className='arch-carousel' options={options} responsive={responsive} margin={12} nav key={Date.now()}>
                            {archItems.map(item => (
                                <span className="item archive">
                                    {item.data.img1 && <img src={item.data.img1} alt="item-img-1" />}
                                    <div className="name">{item.data.name} <span>{item.data.colorway}</span></div>
                                    <div className="price">{item.data.price} <span>{item.data.currency}</span></div>
                                    <div className="time">{item.data.day}<span>{item.data.month}</span></div>
                                    <div className={`women ${item.data.women ? 's' : ''}`}><i className="fa-solid fa-venus"></i></div>
                                </span>
                            ))}
                        </OwlCarousel>
                    </div>
                </section>
            </AnimatePage>
        </div>
    );
}


export default Home;
